/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModuleWithProviders, Type } from '@angular/core'
import { PanelConfig } from '@helios/panel-base'
import {
  AccountDetailsModule,
  AccountDetailsPanelConfig,
} from '@helios/panels/account-details'
import {
  AccountListModule,
  AccountListPanelConfig,
} from '@helios/panels/account-list'
import { ApprovalsModule, ApprovalsPanelConfig } from '@helios/panels/approvals'
import {
  BulkClearwaterTransactionsModule,
  BulkClearwaterTransactionsPanelConfig,
} from '@helios/panels/bulk-clearwater-transactions'
import {
  BulkExternalTransactionsModule,
  BulkExternalTransactionsPanelConfig,
} from '@helios/panels/bulk-external-transactions'
import { ClearwaterTransactionsPanelModule } from '@helios/panels/clearwater-transactions'
import {
  CorporateActionsModule,
  CorporateActionsPanelConfig,
} from '@helios/panels/corporate-actions'
import { DevtoolsModule, DevtoolsPanelConfig } from '@helios/panels/devtools'
import {
  DistributionsModule,
  DistributionsPanelConfig,
} from '@helios/panels/distributions'
import {
  ExternalAccountsModule,
  ExternalAccountsPanelConfig,
} from '@helios/panels/external-accounts'
import {
  ExternalFileManagerModule,
  ExternalFileManagerPanelConfig,
} from '@helios/panels/external-file-manager'
import {
  ExternalFileViewerModule,
  ExternalFileViewerPanelConfig,
} from '@helios/panels/external-file-viewer'
import { ExternalTransactionsPanelModule } from '@helios/panels/external-transactions'
import {
  GettingStartedModule,
  GettingStartedPanelConfig,
} from '@helios/panels/getting-started'
import { JobsModule, JobsPanelConfig } from '@helios/panels/jobs'
import {
  MultiBreaksModule,
  MultiBreaksPanelConfig,
} from '@helios/panels/multi-breaks'
import {
  OutputManagerModule,
  OutputManagerPanelConfig,
} from '@helios/panels/output-manager'
import { PositionsModule, PositionsPanelConfig } from '@helios/panels/positions'
import {
  Positions2Module,
  Positions2PanelConfig,
} from '@helios/panels/positions-2'
import { PricingModule, PricingPanelConfig } from '@helios/panels/pricing'
import {
  RawTradeSummaryModule,
  RawTradeSummaryPanelConfig,
} from '@helios/panels/raw-trade-summary'
import {
  ReconDashboardModule,
  ReconDashboardPanelConfig,
} from '@helios/panels/recon-dashboard'
import { RulesModule, RulesPanelConfig } from '@helios/panels/rules'
import {
  SecurityMappingModule,
  SecurityMappingPanelConfig,
} from '@helios/panels/security-mapping'
import {
  SecurityWebComponentModule,
  SecurityWebComponentPanelConfig,
} from '@helios/panels/security-web-component'
import {
  SmartSuspenseModule,
  SmartSuspensePanelConfig,
} from '@helios/panels/smart-suspense'
import {
  ClarityOpsModule,
  ClarityOpsPanelConfig,
} from '@helios/panels/clarity-ops'
import {
  TransactionDetailModule,
  TransactionDetailPanelConfig,
} from '@helios/panels/transaction-detail'
import {
  TransactionsModule,
  TransactionsPanelConfig,
} from '@helios/panels/transactions'
import {
  Transactions2Module,
  Transactions2PanelConfig,
} from '@helios/panels/transactions-2'
import { UserPolicy } from '@helios/state-management'
/**
 * Add your panel config to the array.
 */
export const Panels: PanelConfig[] = [
  AccountListPanelConfig,
  ExternalAccountsPanelConfig,
  TransactionsPanelConfig,
  Transactions2PanelConfig,
  PositionsPanelConfig,
  Positions2PanelConfig,
  DistributionsPanelConfig,
  PricingPanelConfig,
  ExternalFileManagerPanelConfig,
  CorporateActionsPanelConfig,
  TransactionDetailPanelConfig,
  AccountDetailsPanelConfig,
  GettingStartedPanelConfig,
  ExternalFileViewerPanelConfig,
  MultiBreaksPanelConfig,
  JobsPanelConfig,
  SecurityWebComponentPanelConfig,
  BulkClearwaterTransactionsPanelConfig,
  BulkExternalTransactionsPanelConfig,
  DevtoolsPanelConfig,
  SecurityMappingPanelConfig,
  RulesPanelConfig,
  ApprovalsPanelConfig,
  RawTradeSummaryPanelConfig,
  ReconDashboardPanelConfig,
  SmartSuspensePanelConfig,
  OutputManagerPanelConfig,
  ClarityOpsPanelConfig,
]
/**
 * Add the module that your panel is registered with into the array.
 */
export const PanelModules: (any[] | Type<any> | ModuleWithProviders<any>)[] = [
  AccountListModule,
  ExternalAccountsModule,
  GettingStartedModule,
  ClearwaterTransactionsPanelModule,
  ExternalTransactionsPanelModule,
  PositionsModule,
  Positions2Module,
  ExternalFileManagerModule,
  TransactionDetailModule,
  AccountDetailsModule,
  DistributionsModule,
  PricingModule,
  TransactionsModule,
  Transactions2Module,
  CorporateActionsModule,
  ExternalFileViewerModule,
  MultiBreaksModule,
  JobsModule,
  SecurityWebComponentModule,
  SecurityMappingModule,
  BulkClearwaterTransactionsModule,
  BulkExternalTransactionsModule,
  DevtoolsModule,
  RulesModule,
  ApprovalsModule,
  RawTradeSummaryModule,
  ReconDashboardModule,
  SmartSuspenseModule,
  OutputManagerModule,
  ClarityOpsModule,
]

/**
 * Filters all panels by the ones that are available to the user.
 * Allows use of feature flags in the near future.
 *
 * Two independent gates: `accessPermission` on who the user is, and `hideInProduction` on where
 * the app is running — the latter keeps a panel that is still being built out on alpha/beta/stg
 * and off prd1/prd2.
 */
export function getAvailablePanels(
  isProd: boolean,
  userPolicy: UserPolicy,
): PanelConfig[] {
  return Panels.filter(
    p =>
      (p.accessPermission == null || userPolicy[p.accessPermission]) &&
      !(isProd && p.hideInProduction),
  )
}

/**
 * Filters all panels by the ones that are external.
 */
export function getExternalPanels(): PanelConfig[] {
  return Panels.filter(p => p.isExternal)
}
